import { LucideIcon } from "lucide-react";
import * as React from "react";
import { Link } from "react-router-dom";

export function CollapsibleSideContent({
  href,
  text,
  Icon,
}: {
  href: string;
  text: string;
  Icon: LucideIcon | React.ReactNode;
}) {

  return (
    <Link
      to={href}
      className="flex items-center space-x-4 text-gray-400 hover:text-white p-1 rounded hover:bg-gray-700"
    >
      <Icon size={16} />
      <span>{text}</span>
    </Link>
  );
}
